module.exports = __webpack_public_path__ + "assets/img/eu-gdpr-compliant.dfb6f258.png";